import { isNull } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { SearchFieldSection } from '../../../datasets/instances/store';
import { FieldSearch } from '../../../shared/datasets/FieldSearch';
import { PageLoadingDots } from '../../../shared/loading-dots/PageLoadingDots';
import { OverflowTooltip } from '../../../shared/tooltip';
import { ReportDatasetDefinition } from '../definitions-view/ReportDatasetDefinition';
import styles from '../Reports.module.scss';
import { getFieldSectionSearchValue, getIsLoading, getParentDatasetId, getReportAgreementTypeIds, getReportDatasetDefinitions, getSearchFieldSection, getSearchFuzzyMatches, setFuzzyMatchSearchValue, setSearchFieldSection, setSearchFuzzyMatches } from '../store';
import { AgreementTypeTabs } from './AgreementTypeTabs';

export const DocumentReportFields: React.FC = () => {
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(getIsLoading);
    const datasetDefinitions = useAppSelector(getReportDatasetDefinitions);
    const searchFieldSection = useAppSelector(getSearchFieldSection);
    const fuzzyMatches = useAppSelector(getSearchFuzzyMatches);
    const searchValue = useAppSelector(getFieldSectionSearchValue);
    const parentDatasetId = useAppSelector(getParentDatasetId);
    const reportAgreementTypeIds = useAppSelector(getReportAgreementTypeIds);
    const parentDefinition = useMemo(() => datasetDefinitions.find(({ datasetId }) => datasetId === parentDatasetId) || null, [datasetDefinitions, parentDatasetId]);

    const updateSearchFieldSection = useCallback((match: SearchFieldSection | null) => dispatch(setSearchFieldSection(match)), [dispatch]);
    const updateSearchFuzzyMatches = useCallback((fuzzyMatches: SearchFieldSection[]) => dispatch(setSearchFuzzyMatches(fuzzyMatches)), [dispatch]);
    const updateFuzzyMatchSearchValue = useCallback((value: string) => dispatch(setFuzzyMatchSearchValue(value)), [dispatch]);

    const fieldsHeight = useMemo(() => reportAgreementTypeIds.length > 1 ? 'calc(100% - 121px)' : 'calc(100% - 78px)', [reportAgreementTypeIds]);

    if (isNull(parentDefinition) || isLoading) {
        return <PageLoadingDots label='Retrieving Data Map' />;
    }

    return (
        <div className={styles.reportFieldsWrapper}>
            <AgreementTypeTabs reportAgreementTypeIds={reportAgreementTypeIds} />
            <div className={styles.fieldsHeader}>
                <OverflowTooltip className={styles.fieldsTitle} overlayText='Select the fields you would like to include in your report from the relevant data map' />
                <div className={styles.reportFieldsSearchWrapper}>
                    <FieldSearch
                        searchFieldSection={searchFieldSection}
                        fuzzyMatches={fuzzyMatches}
                        id='document-report'
                        searchValue={searchValue}
                        updateFuzzyMatchSearchValue={updateFuzzyMatchSearchValue}
                        updateSearchFieldSection={updateSearchFieldSection}
                        updateSearchFuzzyMatches={updateSearchFuzzyMatches}
                    />
                </div>
            </div>
            <div className={styles.fieldsSubheaderWrapper}>
                <div className={styles.fieldsSubheader}>If a table dataset field is selected, all fields from other table datasets will be disabled</div>
            </div>
            <div className={styles.allFieldsWrapper} style={{ height: fieldsHeight }}>
                <ReportDatasetDefinition datasetDefinition={parentDefinition} parents={0} parentFieldId='' />
            </div>

        </div>
    );
};
